module.exports = __webpack_public_path__ + "static/img/ramka_zielona.7c58209b.png";